import { createIcon } from '@chakra-ui/react';

export const VidaSimplesIcon = createIcon({
  displayName: 'VidaSimplesIcon',
  viewBox: '0 0 96 101',
  path: [
    <path
      key="1"
      d="M63.046 63.2308L63.0452 38.777C63.0485 36.0593 65.2945 33.8357 68.0385 33.8357C70.7834 33.8365 73.0303 36.0617 73.0311 38.7819L73.0303 54.401V67.7991C73.0303 67.7991 75.8684 64.4187 79.9006 62.5043C84.51 60.3151 87.7403 59.8905 90.2969 61.2477C93.0153 62.6892 93.0004 65.9878 93.0004 65.9878C93.0004 65.9878 85.7808 72.3477 81.3523 79.3833C78.4902 83.9303 75.7866 87.3508 72.1739 90.93C68.5596 94.51 64.084 97.9624 56.8041 97.9624C49.122 97.9615 41.1848 98.8124 31.061 92.468C33.3789 93.921 36.1708 94.1852 39.1964 94.1844"
      stroke="#0066F3"
      strokeWidth="5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key="2"
      d="M52.9254 60.9719L52.9262 35.0054C52.9262 32.2836 50.6785 30.0568 47.9329 30.0584C45.1872 30.0576 42.9403 32.2836 42.9403 35.0046L42.9412 54.7912L42.9403 31.2954C42.9412 28.5752 40.6934 26.3483 37.947 26.3483C35.2013 26.3475 32.9544 28.5735 32.9552 31.2937V54.7903L32.9544 35.0038C32.9544 32.2828 30.7084 30.0576 27.9627 30.0584C25.2171 30.0576 22.9702 32.2836 22.9702 35.0054V65.9189C15.8975 55.8203 9.57222 55.4162 5.70436 57.4688C2.98596 58.9119 3 62.2097 3 62.2097C3 62.2097 10.2204 68.5704 14.6498 75.6061C17.5119 80.1522 20.2121 83.5719 23.8273 87.1535C27.4417 90.7335 31.9156 94.1851 39.1955 94.1835C52.9246 94.1835 62.9121 84.0906 62.9113 73.1624V44.8971C62.9113 42.1761 60.6644 39.9508 57.9196 39.9517C55.1731 39.9508 52.9262 42.1777 52.9271 44.8979L52.9254 60.9719Z"
      stroke="#0066F3"
      strokeWidth="5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key="3"
      d="M51.4985 11.788V3H51.6637L51.6645 11.7872L51.4985 11.788Z"
      stroke="#146CFA"
      strokeWidth="5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key="4"
      d="M35.186 11.0113L35.2769 10.8755L43.5683 16.3715L43.4775 16.5073L35.186 11.0113Z"
      stroke="#146CFA"
      strokeWidth="5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key="5"
      d="M59.6844 16.5073L59.5928 16.3699L67.885 10.8747L67.9767 11.0121L59.6844 16.5073Z"
      stroke="#146CFA"
      strokeWidth="5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ]
});
